import React, { useState } from 'react';
import { TabContent, Nav, NavItem, NavLink } from 'reactstrap';
import { QueryDetailFields } from '../QueryDetailFields/QueryDetailFields';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/* LOCAL STYLES IMPORT FOR QUERY DETAILS */ 
import '../../assets/components/QueryDetails.scss';

export const QueryDetails = ({ queryDetails, queryType }) => {
    const [activeTab, setActiveTab] = useState('0');

    const toggle = (tab)=> {
        if (activeTab !== tab) {
          setActiveTab(tab);
        }
      }

    return (
        <>
            {queryDetails && queryDetails.map((queryDetail, index)=>{
                    return(
                        <div key={ index }>
                            { queryDetail && queryDetail.gasdetails.length === 0 && queryDetail.elecdetails.length > 0 ?
                                <div key={ index } className="query-details-head">
                                    <Nav className="nav-scroll" tabs>
                                        { queryDetail && queryDetail.elecdetails.map((detail, index)=>{    
                                            return(
                                                <NavItem key={ index }>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === index.toString() })}
                                                        onClick={() => toggle(index.toString())}
                                                    >
                                                    { detail.mpan }
                                                    </NavLink>
                                                </NavItem>
                                                )
                                            })
                                        }
                                    </Nav>
                                    <TabContent activeTab={activeTab}>
                                        { queryDetail && queryDetail.elecdetails.map((detail, index)=>{
                                            return(
                                                    <QueryDetailFields 
                                                        key={ index }
                                                        queryType={ queryType }
                                                        detail={ detail }
                                                        index = { index }
                                                    />
                                                )
                                            })
                                        }
                                    </TabContent>
                                </div> 
                                : queryDetail && queryDetail.elecdetails.length === 0 && queryDetail.gasdetails.length > 0 ?
                                <div key={ index } className="query-details-head">
                                <Nav tabs>
                                    { queryDetail && queryDetail.gasdetails.map((detail, index)=>{    
                                        return(
                                            <NavItem key={ index }>
                                                <NavLink
                                                className={classnames({ active: activeTab === index.toString() })}
                                                onClick={() => toggle(index.toString())}
                                                >
                                                { detail.mprn }
                                                </NavLink>
                                            </NavItem>
                                            )
                                        })
                                    }
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    { queryDetail && queryDetail.gasdetails.map((detail, index)=>{
                                        return(
                                                <QueryDetailFields 
                                                    key={ index }
                                                    queryType={ queryType }
                                                    detail={ detail }
                                                    index = { index }
                                                />
                                            )
                                        })
                                    }
                                </TabContent>
                            </div>
                            :
                            <QueryDetailFields 
                                key={ index }
                                queryType={ queryType }
                                index = { index }
                            />
                        }
                        </div>
                     )
                })
            }
        </>
    );
};

QueryDetails.propTypes = {
    /* 
      contains the details of the query
    */ 
    queryDetails: PropTypes.array.isRequired,
    /* 
      containes the types of the query
    */ 
    queryType: PropTypes.number.isRequired,
  }
  
  QueryDetails.defaultProps = {
    /*
        default value if details of the query is not given
    */
    queryDetails: [],
    /*
        default value if types of the query is not given
    */
    queryType: 0,
}